import styled from 'styled-components'
import slideInFromLeftAnimation from '../style/animations.css'

const SkeletonLoader = styled.div`
  height: 1.2rem;
  background-color: ${props => props.color || 'rgba(0, 0, 0, 0.11)'};
  position: relative;
  overflow: hidden;
  &:after {
    content: "";
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    position: absolute;
    animation: ${slideInFromLeftAnimation} 1.6s linear 0.5s infinite;
    background: linear-gradient(90deg, transparent, ${props => props.color || 'rgba(0, 0, 0, 0.11)'}, transparent);
    transform: translateX(-100%);
  }
`

export default SkeletonLoader
